import React from 'react';
import ReactDOM from 'react-dom/client';
import './styles/global.css'; 
import App from './App';
import { handleSessionExpiry } from './lib/axios';

if (process.env.NODE_ENV === 'production') {
    console.log = () => {};
    console.info = () => {};
    console.debug = () => {};
    console.warn = () => {};
}

// Global fetch interceptor for session expiry handling
const originalFetch = window.fetch;
window.fetch = async function(...args) {
    const response = await originalFetch(...args);

    // Check for 401 Unauthorized or specific token validation errors
    if (response.status === 401) {
        try {
            const clone = response.clone();
            const data = await clone.json();
            const isTokenExpired = data?.code === 'token_not_valid' || 
                (data?.messages && data.messages.some(m => m.message === 'Token is expired'));
                
            const isAuthPage = ['/signin', '/signup', '/forgot-password'].includes(window.location.pathname);
            
            if (isTokenExpired || (!isAuthPage)) {
                console.warn('Fetch Interceptor: 401/Token expired. Redirecting to login...');
                handleSessionExpiry('Session expired. Please login again.');
            }
        } catch (e) {
            // Unparseable JSON on 401, mostly still implies unauthorized
            const isAuthPage = ['/signin', '/signup', '/forgot-password'].includes(window.location.pathname);
            if (!isAuthPage) {
                console.warn('Fetch Interceptor: 401 Unauthorized. Redirecting to login...');
                handleSessionExpiry('Session expired. Please login again.');
            }
        }
    } 
    // Handle APIs returning 200 with 'MT' indicating session expiration
    else if (response.status === 200) {
        try {
            const clone = response.clone();
            const text = await clone.text();
            if (text === 'MT' || text === '"MT"' || text === 'Invalid token' || text === 'Token expired') {
                console.warn('Fetch Interceptor: Auth token invalid (MT). Redirecting to login...');
                handleSessionExpiry('Session expired or invalid. Please login again.');
            }
        } catch (e) {
            // Ignore if unable to read text, it's just standard flow
        }
    }

    return response;
};

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(<App />);